/* global notifications:true */
/* jshint camelcase: false */

/**
 * Object: step
 * Purpose: This object creates and manipulates the DOM for steps in the View. It is currently in use for admin/process.
 */
notifications = function(id) {
	'use strict';

	var objDialog = dialog();
	var objValidation = validation();
	var objDom = dom();
	var objSettings = settings();

	/*
	 * Function launchProposal
	 * Purpose: When user launches a proposal, this dialog will launch showing them their workflow and asking them to confirm.
	 */
	notifications.newTemplate = function() {

		var dialog = objDialog.createDOMDialog('new-notifications-template-dialog', function(dialog, defaults) {

			// Actions
			defaults.buttons = {
				'Create Template': function() {

					var data = {
						name : $('#notification-name').val(),
						displayName : $('#notification-display-name').val(),
						subject : $('#notification-subject').val(),
						type : $('#notification-type').val(),
						textVersion : $('#notification-text-version').val(),
						dashboardVersion : $('#notification-dashboard-version').val(),
						htmlVersion : $('#notification-html-version').val(),
						tags: $('#notification-tags').val()
					};


					$.ajax({
						url: '/admin/notifications.json',
						type: 'POST',
						data: data,
						beforeSend: function() {
							objDom.addMask('#summary-10');
							objDom.addMask('new-notifications-template-dialog');
						},
						complete: function() {
							objDom.removeMask('new-notifications-template-dialog');
						},
						success: function(data) {
							notifications.loadData();
						}
					});

					$(this).dialog('close');

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};

			defaults.open = function() {
				//CKEDITOR.replace('notification-html-version', {toolbar:'Notifications'});

				$('#notification-html-version').ckeditor({
					resize_enabled: false,
					bodyClass: 'richtext-field',
					height: 100,
					toolbar: [{
						name: 'clipboard',
						items: [ 'Bold','Italic','Underline', 'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','NumberedList','BulletedList','Link','HorizontalRule','SpecialChar','Font','FontSize']
					}]
				});

				$('#notification-dashboard-version').ckeditor({
					resize_enabled: false,
					bodyClass: 'richtext-field',
					toolbar: 'Dashboard',
					height: 100,
					toolbar_Dashboard: [{
						name: 'clipboard',
						items: [ 'Bold','Italic','Underline', 'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','NumberedList','BulletedList','Link','HorizontalRule','SpecialChar','Font','FontSize']
					}]
				});

				$('#notification-tags').ckeditor({
					resize_enabled: false,
					bodyClass: 'richtext-field',
					toolbar: 'Full',
					height: 100,
					toolbar_Full: [{
						name: 'clipboard',
						items: [ 'Bold','Italic','Underline', 'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','NumberedList','BulletedList','Link','HorizontalRule','SpecialChar','Font','FontSize']
					}]
				});

			};

			defaults.close = function(event, ui) {
				$('#notification-html-version').ckeditorGet().destroy();

				// clear data
				$('#notification-name').val('');
				$('#notification-display-name').val('');
				$('#notification-type').val('');
				$('#notification-subject').val('');
				$('#notification-text-version').val('');
				$('#notification-dashboard-version').val('');
				$('#notification-html-version').val('');
				$('#notification-tags').val('');
			};

			defaults.width = 800;
			$(dialog).dialog(defaults);
			//$(dialog).dialog({'zIndex':-1});

		});
	};

	notifications.loadData = function() {
		$('#summary-10').load('/admin/settings #summary-10>*', '', function(responseText, textStatus, xmlHttpRequest) {
			objDom.removeMask('#summary-10');
			objDom.verticalStretchList();
		});
	};


	notifications.editTemplate = function(id) {

		var dialog = objDialog.createDOMDialog('new-notifications-template-dialog', function(dialog, defaults) {

			// get data
			$.ajax({
				url: '/admin/notifications:' + id + '.json',
				type: 'GET',
				
				complete: function() {
					objDom.removeMask('#new-notifications-template-dialog');
				},
				success: function(data) {
					$('#notification-name-view').html('<span class="strong">' + data.notificationTemplate.name + '</span>');
					$('#notification-display-name-view').html(data.notificationTemplate.displayName);
					$('#notification-subject').html(data.notificationTemplate.subject);
					$('#notification-html-version').html(data.notificationTemplate.htmlVersion);
				}
			});

			// Actions
			defaults.buttons = {
				Ok: function() {
					$(this).dialog('close');
				}
			};

			defaults.close = function(event, ui) {
				$('#notification-name-view').html('');
				$('#notification-display-name-view').html('');
				$('#notification-subject').html('');
				$('#notification-html-version').html('');
			};

			defaults.width = 800;
			$(dialog).dialog(defaults);
			
			objDom.addLoadingMask('#new-notifications-template-dialog');

		});
	};

	notifications.deleteTemplate = function(id) {
		$.ajax({
			url: '/admin/notifications:' + id + '/template.json',
			type: 'DELETE',
			beforeSend: function() {
				objDom.addMask('#summary-10');
			},
			success: function() {
				// hermes has callbacks...not sure how to set this up with this
				//$('#summary-10').load('/admin/settings #summary-10>*', '', function(responseText, textStatus, xmlHttpRequest) {
				objSettings.getFlyout(10);

			}
		});
	};

	notifications.deleteType = function(id) {
		$.ajax({
			url: '/admin/notifications:' + id + '/type.json',
			type: 'DELETE',
			beforeSend: function() {
				objDom.addMask('#summary-10');
			},
			success: function() {
				//$('#summary-10').load('/admin/settings #summary-10>*', '', function(responseText, textStatus, xmlHttpRequest) {
				objSettings.getFlyout(10);

			}
		});
	};

	notifications.newType = function() {

		var dialog = objDialog.createDOMDialog('new-notifications-type-dialog', function(dialog, defaults) {

			// Actions
			defaults.buttons = {
				'Add Type': function() {

					var data = {
						type : $('#new-notification-type').val(),
					};


					$.ajax({
						url: '/admin/notifications/newType.json',
						type: 'POST',
						data: data,
						beforeSend: function() {
							objDom.addMask('#summary-10');
							objDom.addMask('new-notifications-template-dialog');
						},
						complete: function() {
							objDom.removeMask('new-notifications-template-dialog');
						},
						success: function(data) {
							if (parseInt(data.error, 10) === 1) {
								$('#growls').notify('create', 'warning-template', {
									text: data.msg
								});
								objDom.removeMask('#summary-10');
							} else {
								objSettings.getFlyout(10);
							}
						}
					});

					$(this).dialog('close');

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};

			defaults.close = function(event, ui) {
				$('#new-notification-type').val('');
			};

			$(dialog).dialog(defaults);
			//$(dialog).dialog({'zIndex':-1});

		});
	};

	return notifications;

};
